import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./Firebase";
import type { InterviewTier } from "./interviewApi";

const functions = getFunctions(firebaseApp, "asia-south1");

export type InterestType = "workshop" | "internship" | "mock_interview";
export type InterestSubmission = {
    name: string;
    email: string;
    mobile: string;
    college: string;
    branch?: string;
    year?: string;
    preparation?: string;
    interestType: InterestType;
    sourcePage: string;
    selectedCategory?: string;
    website?: string;
};

export type PublicInterviewSlotRequest = {
    name: string;
    email: string;
    mobile: string;
    tier: InterviewTier;
    targetRole: string;
    preferredDate?: string;
    timezone: string;
    sourcePage: string;
    website?: string;
};

export async function submitInterest(data: InterestSubmission) {
    const result = await httpsCallable<InterestSubmission, { ok: true; interestId: string }>(functions, "submitPublicInterest")(data);
    return result.data;
}

export async function submitPublicInterviewSlotRequest(data: PublicInterviewSlotRequest) {
    const result = await httpsCallable<PublicInterviewSlotRequest, { interviewRequestId: string; messageCreated: true }>(functions, "submitPublicInterviewSlotRequest")(data);
    return result.data;
}
